
/*
 * Filename: tooltip.js
 * By: J. Nguyen
 * Date: 04/13/23
 *
 * Description: 
 * This template will be used for reusable site modules.  Be sure to only use vanilla JS.
 * All the variables and functions which are not exported are private within the module and cannot be used outside. 
 * Only the exported members are public and can be used by importing them.
 *
 *  Used in conjunction with /scss/partials/components/_tooltip.scss
 *  Expected Markup
 *  <label class="tooltip__label" for="">
      Label Text 
      <div class="tooltip">
        <button class="tooltip__trigger">
          <span class="tooltip__icon">?</span>
        </button>
        <div class="tooltip__msg tooltip__msg--hide">Tooltip Message</div>
      </div>
    </label>
 *
 */


export default function Tooltip(element, optionOverwrites) {

  const elem = element;                       // parent element of all tooltips, pass <body> element if needed page wide.
  let api = {};                               // Object to contain the publicly accessible functions

  // default options
  const defaults = {
    debugMode: false
  };

  // overwrite options based on optionOverwrites
  const options = Object.assign(defaults, optionOverwrites);
  
  // DOM NODES
  //const node1 = elem.getElementById('id');
  const tooltips = elem.getElementsByClassName('tooltip__label');
  const tooltipTriggers = elem.getElementsByClassName('tooltip__trigger');
  const messages = elem.getElementsByClassName('tooltip__msg');

  // DATA VARIABLES - private variables
  const hideClass = 'tooltip__msg--hide';

  init();

  // initilize the module
  function init() {
    debug('insider Tooltip init()');

    // setup tooltip handlers 
    for (let x = 0; x < tooltipTriggers.length; x++){
      tooltipTriggers[x].addEventListener("mouseover", showTooltip);
      tooltipTriggers[x].addEventListener("mouseout", hideAllTooltipMsgs);
      tooltipTriggers[x].addEventListener("click", showTooltip);
      tooltipTriggers[x].addEventListener("blur", hideAllTooltipMsgs);
    }

  }


  // HELPER FUNCTIONS
  //===============================================
  
  // Basic debug function
  function debug(msg) { 
    if (defaults.debugMode) {
      console.log(msg);
    }
  }

  // PUBLIC FUNCTIONS
  //===============================================
  
  // function to hide all tooltip messages
  function hideAllTooltipMsgs() {
    for (let x = 0; x < messages.length; x++){
      messages[x].classList.add(hideClass);
    }
  }
  
  
  // function to show tooltip message
  function showTooltip(event) {
    event.preventDefault();

    const button = event.target;
    const parentDiv = button.closest('.tooltip');
    const message = parentDiv.querySelector(".tooltip__msg");

    message.classList.remove(hideClass);
  }
  
  
  // EXPOSE PUBLIC FUNCTIONS VIA THE API
  // Map all the functions we want to expose for public access
  //===============================================================
  api.hideAllTooltipMsgs = hideAllTooltipMsgs;
  api.showTooltip = showTooltip;
  return api;

}
